import {absCenter, absCenterY, clearfix, font_s_md} from '@xpertdox_js/xdstyle';
import {colors} from '../defaultSettings';

export default {
  container: {
    ...clearfix,
    ...font_s_md,
    borderBottom: '1px solid ' + colors.headerMenuBorderDrk,
    background: colors.bg.header,
    whiteSpace: 'nowrap',
    transition: 'width .18s ease-out',
    zIndex: 20,
  },
  headerCell: {
    display: 'inline-block',
    position: 'relative',
    height: '55px',
    fontWeight: 'bold',
    marginBottom: '-4px',
    verticalAlign: 'top',
    transition: 'width .18s ease-out'
    // overflow: 'hidden',
  },
  headerTab: {
    background: colors.bg.header,
    height: '20px',
    width: '100%',
    // borderRight: '1px solid ' + colors.headerMenuBorderDrk,
    borderBottom: '1px solid ' + colors.headerMenuBorderDrk
  },
  headerBuffer: {
    background: colors.bg.header,
    color: colors.headerText,
    padding: 0,
    // borderRight: '1px solid ' + colors.headerMenuBorderDrk,
    borderRight: 0,
    width: '100%',
    fill: colors.headerText,
    position: 'absolute',
    left: 0,
    right: 0,
    top: '20px',
    height: '35px',
  },
  headerBufferHov: {
    background: colors.bg.headerHov,
  },
  headerBufferAct: {
    background: colors.bg.headerAct,
    // color: colors.actionActText,
    fill: colors.highlightText,
    color: colors.highlightText,
  },
  headerBufferFoc: {
    // color: colors.highlight,
  },
  headerText: {
    lineHeight: '14px',
    margin: 0,
    display: 'block'
  },
  sortIndicator: {
    ...absCenterY,
    left: '4px',
    width: '16px',
  },
  sortSvg: {
    display: 'block',
    ...absCenter,
    width: '80%',
    height: 'auto'
  },
  headerSpacer: {
    display: 'block',
    width: '1px',
    borderRadius: '5px',
    height: '60%',
    ...absCenterY,
    background: colors.panelBorder,
    left: 'auto',
    right: 0,
  },
  cellContent: {
    padding: '2px 2px 2px 12px',
    ...absCenter,
    width: '100%',
    textAlign: 'left',
    // fontWeight: 'bold',
    ...font_s_md,
  },
  lineNumberPlaceholer: {
    width: '15px',
    float: 'left',
    height: '55px',
    display: 'inline-block',
    background: colors.bg.header,
    borderRight: '1px solid ' + colors.panelBorder,
    // borderRight: 0,
    position: 'relative',
    zIndex: 3,
  },
  input: {
    background:  colors.bg.panelInput,
    color: colors.textGray,
    width: '45px',
    textAlign: 'center',
    padding: '10px',
    marginLeft: '5px',
    borderRadius: '5px',
    border: '1px solid ' + colors.opacShadeLt,
    boxShadow: 'inset 0px 1px 4px rgba(0,0,0,0.09)',
  },
}
